import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from "react-router-dom";

export default function WorkFooter({workNext,workNextTitle, workPrevious,workPreviousTitle}) {   
    const _next = workNext.split("|");
    const _previous = workPrevious.split("|");

    const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth' // for smoothly scrolling
        });
    };
    return (
        <>
            <Row className="py-3 d-flex flex-wrap align-items-center">
                <Col>
                    <button onClick={scrollToTop}>
                        <img alt='' src='/img/footertotop.png'/>&nbsp;Back to Top
                    </button>                    
                </Col>
            </Row>
            <Row>
                <Col>
                <Link to={`/${_previous[0]}`} className='worklink2'>
                        <Row className='d-flex flex-wrap align-items-center'>
                            <Col className="text-end px-0" lg='3' sm='3' xs='4'>
                                <span >
                                    <img alt='' className='center-block' src='/img/chevron-left.png'/>
                                </span>
                            </Col>
                            <Col className='text-start px-0'>
                                <div className="media-body">
                                    <span className='workBold'>{workPreviousTitle}</span>
                                </div>
                            </Col>
                        </Row>
                    </Link>            
                </Col>
                <Col lg='4' md='4' sm='1'  xs='1'></Col>
                <Col>
                    <Link to={`/${_next[0]}`} className='worklink2'>
                        <Row className='d-flex flex-wrap align-items-center'>
                            <Col className='text-end px-0'>
                                <div className="media-body">
                                    <span className='workBold'>{workNextTitle}</span>
                                </div>
                            </Col>
                            <Col className="text-start px-0" lg='3' sm='3' xs='4'>
                                <span >
                                    <img alt='' className='center-block' src='/img/chevron-right.png'/>
                                </span>
                            </Col>
                        </Row>
                    </Link>
                </Col>
            </Row>
        </>
    );
  }